import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { AppContext } from '../../AppProvider';
import _get from 'lodash/get';
import combineStyles from '../../utils/combineStyles';
import { withStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import TypographyStyles from '../../styles/typography';
import LayoutStyles from '../../styles/layout';
import SpacingStyles from '../../styles/helpers/spacing';
import BOLStyles from './__styles__/BOL.styles';
import WarningIcon from '@material-ui/icons/Warning';
import FormItemContainerStyles from '../../components/Global/Containers/__styles__/FormItemContainer.styles';
import { CURRENCY_SYMBOL, UNIT_ABBREVIATIONS } from '../../constants/constants';

class ItemInfo extends Component {
  static propTypes = {
    item: PropTypes.object.isRequired
  };

  state = {};

  render() {
    const { item, classes, t } = this.props;
    const classText = _get(item, 'product.freightInfo.freightClassName', '--');
    const hazMatClass = _get(item, 'product.hazMat.hazMatClassId', '');
    const hazMatGroup = _get(item, 'product.hazMat.hazMatPackingGroupId', '');

    return (
      <tr className={classnames(classes.unitHeaderText, classes.tableRow)}>
        <td>{item.product.sku}</td>
        <td>{item.quantity}</td>
        <td>{item.product.name}</td>
        <td>{classText}</td>
        <td>
          {item.product.freightInfo.nmfcItemCode}-
          {item.product.freightInfo.nmfcSubCode}
        </td>
        <td>{item.product.packageTypeId}</td>
        <td className={classes.hazMatWarning}>
          {item.product.isHazMat ? <WarningIcon /> : ''}
        </td>
        {!item.product.isHazMat && <td>{item.product.description}</td>}
        {item.product.isHazMat && (
          <td>
            <p className={classes.hazMatCell}>
              {item.product.hazMat.properShippingName}, {hazMatClass},{' '}
              {item.product.hazMat.unNumber}, {hazMatGroup}
              <br />
              <span classes={classes.hazMatContact}>
                {t('EMERGENCY CONTACT')}: <br />
                {item.product.hazMat.contactFirstName}{' '}
                {item.product.hazMat.contactLastName}
                <br />
                {item.product.hazMat.contactPhone}
              </span>
            </p>
          </td>
        )}

        <td>
          {item.product.weightInfo.weight}{' '}
          {UNIT_ABBREVIATIONS[item.product.weightInfo.weightUnit]}
        </td>
        <td>
          {CURRENCY_SYMBOL[item.product.valueInfo.currency]}
          {item.product.valueInfo.value}
        </td>
      </tr>
    );
  }
}

ItemInfo.contextType = AppContext;
const translatedItemInfo = withNamespaces()(ItemInfo);
export default withStyles(
  combineStyles(
    BOLStyles,
    FormItemContainerStyles,
    TypographyStyles,
    LayoutStyles,
    SpacingStyles
  )
)(translatedItemInfo);
